import React, { useState, useEffect } from 'react';
import { Typography, Input } from 'antd';
import crosshairIcon from '../../assets/icons/crosshair.png';
import BusinessSizeCalculator from '../businessSizeCalculator';
import { Label, Tooltip } from 'components';
import { ReactComponent as Info } from '../../assets/icons/info-icon.svg';
import { useSelector } from 'react-redux';

const { Text } = Typography;

const BusinessSizeField = props => {
  const {
    value,
    onChange,
    disabled,
    placeholder,
    label,
    name,
    size,
    asterisk = true,
    ...rest
  } = props;

  //console.log('BusinessSizeField asterisk prop:', asterisk);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [displayValue, setDisplayValue] = useState('');
  const viewMode = useSelector(state => state.forms.carrier.viewMode);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const handleSave = businessSize => {
    // Set the local display value
    setDisplayValue(businessSize);

    if (onChange) {
      onChange({
        key: name,
        type: 'businessSize',
        event: businessSize,
      });
    }
  };

  const displayText =
    displayValue || (typeof value === 'string' ? value : value?.event || '');

  const linkStyle = {
    color: '#1890ff',
    textDecoration: 'underline !important',
    cursor: 'pointer',
    //borderBottom: '1px solid #1890ff',
    display: 'inline-block',
    position: 'relative',
  };

  useEffect(() => {
    if (value) {
      // Handle both string and object formats
      if (typeof value === 'string') {
        setDisplayValue(value);
      } else if (value.event) {
        setDisplayValue(value.event);
      }
    }
  }, [value]);

  //console.log('BusinessSizeField value prop:', value);

  return (
    <div className="business-size-field">
      <div style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Label
          label="Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ"
          asterisk={asterisk}
        />
        <Tooltip
          placement="right"
          className="ml-1"
          title={
            <div className="tooltip-container">
              <span className="info-icon-content">
                Σύμφωνα με τη σύσταση 2003/361 της Επιτροπής, οι πολύ μικρές και
                μικρές επιχειρήσεις είναι εταιρείες που ο αριθμός του προσωπικού
                τους και το οικονομικό βάρος τους δεν ξεπερνούν ορισμένα όρια:
                <br />
                <br />
                {`Πολύ Μικρή Επιχείρηση: Έως και 10 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών ή Ισολογισμός <= 2.000.000,00€`}
                <br />
                <br />
                {`Μικρή Επιχείρηση: Έως και 50 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών ή Ισολογισμός <= 10.000.000,00€`}
                <br />
              </span>
            </div>
          }
        >
          <Info className="infoIconSmallIban" />
        </Tooltip>
      </div>
      <Input
        value={displayText}
        placeholder="Εισάγετε Μέγεθος Επιχείρησης"
        disabled={true}
        readOnly
        size={size || 'large'}
        className="ant-input"
      />

      {!viewMode && (
        <>
          <div
            style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}
          >
            <img
              src={crosshairIcon}
              alt="crosshair"
              style={{ marginRight: '8px' }}
            />
            <span
              id="businessSizeCalc"
              onClick={showModal}
              style={{
                ...linkStyle,
                textDecoration: 'underline !important',
              }}
            >
              <span
                id="businessSizeCalc"
                style={{
                  textDecoration: 'underline !important',
                  borderBottom: '1px solid #1890ff',
                }}
              >
                Βρες το μέγεθος της επιχείρησης
              </span>
            </span>
          </div>

          <BusinessSizeCalculator
            visible={isModalVisible}
            onClose={handleClose}
            onSave={handleSave}
            initialValues={{
              annualTurnover: '',
              annualBalance: '',
              numberOfEmployees: '',
            }}
          />
        </>
      )}
    </div>
  );
};

export default BusinessSizeField;
